import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Icon } from 'antd';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import { selectorLogin } from '../../../selectors/selector_login';
import { inicialitzaObservacio } from '../../../actions';
import {
    rutaObservacions,
    rutaAvisos,
    rutaEstacions,
    rutaUsuaris,
    rutaPerfil
} from '../../../routes/routeConstants';

import {
    esPotAccedirSeccioEstacions,
    esPotAccedirSeccioUsuaris
} from '../../../commons/callbacksSeguretat';

import Logout from './logout';
import ModificarContrasenya from './modificarContrasenya';
import seguretatWrapper from '../../seguretat/seguretatWrapper';

const { SubMenu } = Menu;

const obtenirOpcioSeleccionada = urlActual => {
    const rutesDisponibles = [rutaObservacions, rutaAvisos, rutaEstacions, rutaUsuaris, rutaPerfil];
    return rutesDisponibles.find(ruta => urlActual.startsWith(ruta));
};

const generarOpcioMenu = (nom, rutaRedireccio, opcioSeleccionada, onClick) => {

    const onClickSiNoSeleccionadaActualment = () => {
        if (onClick && opcioSeleccionada !== rutaRedireccio ) {
            onClick();
        }
    };

    return (
        <Link to={rutaRedireccio} onClick={onClickSiNoSeleccionadaActualment} onlyActiveOnIndex={true}>
            {nom}
        </Link>
    );

};

const MenuApp = (props) => {
    const {
        urlActual,
        classeCssMenu,
        modeMenu,
        onClickMenuItem,
        inicialitzaObservacio,
        estilsMenu
    } = props;

    let opcioSeleccionada = obtenirOpcioSeleccionada(urlActual);

    const titolAreaUsuari = <span><Icon type="user" />Àrea d'usuari</span>;

    const opcioObservacions = generarOpcioMenu('Observacions', rutaObservacions, opcioSeleccionada, inicialitzaObservacio);
    const opcioAvisos = generarOpcioMenu('Avisos', rutaAvisos, opcioSeleccionada);
    const opcioEstacions = generarOpcioMenu('Estacions', rutaEstacions, opcioSeleccionada);
    const opcioUsuaris = generarOpcioMenu('Usuaris', rutaUsuaris, opcioSeleccionada);
    const opcioPerfil = generarOpcioMenu('Perfil', rutaPerfil, opcioSeleccionada);

    const MenuItemEstacions = seguretatWrapper(Menu.Item, esPotAccedirSeccioEstacions);
    const MenuItemUsuaris = seguretatWrapper(Menu.Item, esPotAccedirSeccioUsuaris);

    return (
        <Menu
            className={classeCssMenu}
            theme="light"
            mode={modeMenu}
            selectedKeys={[opcioSeleccionada]}
            onClick={onClickMenuItem}
            style={estilsMenu}
        >
            <Menu.Item key={rutaObservacions} className='menu-item'>
                {opcioObservacions}
            </Menu.Item>
            <Menu.Item key={rutaAvisos} className='menu-item'>
                {opcioAvisos}
            </Menu.Item>
            <MenuItemEstacions key={rutaEstacions} className='menu-item'>
                {opcioEstacions}
            </MenuItemEstacions>
            <MenuItemUsuaris key={rutaUsuaris} className='menu-item'>
                {opcioUsuaris}
            </MenuItemUsuaris>
            <SubMenu key='area-usuari' className='menu-item' title={titolAreaUsuari}>
                <Menu.Item key={rutaPerfil}>{opcioPerfil}</Menu.Item>
                <Menu.Item key="contrasenya"><ModificarContrasenya /></Menu.Item>
                <Menu.Item key="logout"><Logout /></Menu.Item>
            </SubMenu>
        </Menu>
    );
};

MenuApp.propTypes = {
    urlActual: PropTypes.string,
    classeCssMenu: PropTypes.string,
    modeMenu: PropTypes.string,
    onClickMenuItem: PropTypes.func,
    inicialitzaObservacio: PropTypes.func,
    usuariRegistrat: PropTypes.object,
    estilsMenu: PropTypes.object
};


const mapStateToProps = (state) => {
    return {
        usuariRegistrat: selectorLogin(state)
    };
};

export default connect(mapStateToProps, { inicialitzaObservacio })(MenuApp);



// WEBPACK FOOTER //
// ./src/components/capcalera/menu/menuApp.js